export const userTableHeaders = [
  { label: "User Name", value: "fullName" },
  { label: "Company", value: "companyName" },
  { label: "Email", value: "email" },
  { label: "Subscription Name", value: "subscriptionName" },
  { label: "Phone No.", value: "phoneNumber" },
  { label: "Followers ", value: "followers" },
  { label: "Following", value: "following" },
  { label: "Posts", value: "posts" },
  { label: "O & B", value: "oAndB", headerStyle: { textWrap: "nowrap" } },
  { label: "Registered On", value: "createdAt", headerStyle: { textWrap: "nowrap" } },
  { label: "Status", value: "status" },
  { label: "", value: "actions" },
];

export const dealsTableHeaders = [
  { label: "Title", value: "title" },
  { label: "Posted By", value: "poster" },
  { label: "Country / Type", value: "meta" },
  { label: "Date", value: "date" },
  { label: "Status", value: "status" },
  { label: "", value: "actions" },
];

// Payment History Headers
export const paymentHistoryHeaders = [
  { label: "Transaction ID", value: "transactionId" },
  { label: "Subscription Plan", value: "subscriptionPlan" },
  { label: "Amount Paid", value: "amountPaid" },
  { label: "Status", value: "status" },
  { label: "", value: "actions" },
];

export const productName_table_header = [
  { label: "Sr. No.", value: "srno" },
  { label: "Name", value: "name" },
  { label: "Created By", value: "createdBy" },
  { label: "Created At", value: "createdAt" },
  { label: "Status", value: "status" },
  { label: "", value: "action", width: "100px" },
];

export const plantName_table_header = [
  { label: "Sr. No.", value: "srno" },
  { label: "Name", value: "name" },
  { label: "Link", value: "link" },
  { label: "Created By", value: "createdBy" },
  { label: "Created At", value: "createdAt" },
  { label: "Status", value: "status" },
  { label: "", value: "action", width: "100px" },
];
export const producerQuestions = [
  {
    question: "Do they sell this product locally on market?",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    value: "tradeLocally",
  },
  {
    question: "Do they export this product ?",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    value: "tradeInternationally",
  },
  {
    question: "Is that product captive used?",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    value: "captiveUsed",
  },
];

export const consumerQuestions = [
  {
    question: "Do they sell this product locally on market?",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    value: "tradeLocally",
  },
  {
    question: "Do they export this product ?",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    value: "tradeInternationally",
  },
  {
    question: "Is that product captive used?",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    value: "captiveUsed",
  },
];

export const postQuestions = {
  producer: producerQuestions,
  consumer: consumerQuestions,
};

export const requestEditsHeaders = [
  { label: "Post Id", value: "postId" },
  { label: "Pending Request", value: "pendingEdits" },
  { label: "Accepted Request", value: "acceptedEdits" },
  { label: "Rejected Request", value: "rejectedEdits" },
  { label: "Latest Edit", value: "latestEdit" },
  { label: "", value: "actions" },
];

export const requestEditTableHeaders = [
  { label: "User Name", value: "fullName" },
  { label: "Created At", value: "createdAt" },
  { label: "Status", value: "status" },
  { label: "", value: "actions" },
];

export const posts_table_header = [
  { label: "Type", value: "type" },
  { label: "Product", value: "product" },
  { label: "Plant", value: "plant" },
  { label: "Country", value: "country" },
  { label: "Capacity", value: "capacity" },
  { label: "Created At", value: "createdAt" },
  { label: "", value: "action", width: "100px" },
];

export const paymentTableHeaders = [
  { label: "Invoice ID", value: "transactionId" },
  { label: "Package Name", value: "packageName" },
  { label: "Date", value: "date" },
  { label: "Amount", value: "amount" },
  {
    label: "Action",
    value: "actions",
  },
];
